module.exports = "<sq-log-tracker class=\"flexRowContainer flexFill\"></sq-log-tracker>\n";